import { render, staticRenderFns } from "./ProductTypeTable.vue?vue&type=template&id=2e49c49c&scoped=true"
import script from "./ProductTypeTable.vue?vue&type=script&lang=js"
export * from "./ProductTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49c49c",
  null
  
)

export default component.exports